import { ALLOCATION_DIMENSION } from "constants/action-types";
import type { IAllocationDimension, AllocationDimensionOwnerObject } from "helpers/allocation-dimension";
import { FluxStandardAction as Action } from "flux-standard-action";

export type ListAllocationDimensionRequestAction = Action<
    {
        objectId: string;
        owner: AllocationDimensionOwnerObject;
    },
    undefined
>;
export const listAllocationDimensionRequest = (
    objectId: string,
    owner: AllocationDimensionOwnerObject,
): ListAllocationDimensionRequestAction => ({
    meta: undefined,
    payload: { objectId, owner },
    type: ALLOCATION_DIMENSION.LIST.REQUEST,
});

export type ListAllocationDimensionCompleteAction = Action<IAllocationDimension[] | Error, undefined>;
export const listAllocationDimensionComplete = (
    payload: IAllocationDimension[] | Error,
): ListAllocationDimensionCompleteAction => ({
    meta: undefined,
    payload,
    error: payload instanceof Error,
    type: ALLOCATION_DIMENSION.LIST.COMPLETE,
});

export type CreateAllocationDimensionCompleteAction = Action<
    IAllocationDimension | Error,
    {
        objectId: string;
        owner: AllocationDimensionOwnerObject;
        merchantV0Uuid: string;
    }
>;
